// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  CAR_DATA_MASTER_UPDATE_COMPANY_LIST,
} from './constants';

export function updateCompanyList(text) {
  return {
    type: CAR_DATA_MASTER_UPDATE_COMPANY_LIST,
    text: text
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CAR_DATA_MASTER_UPDATE_COMPANY_LIST:
      let aux = [...state.companyListOrigin];
      aux = aux.filter(company => company.code.toLowerCase().includes(action.text.toLowerCase()) || company.businessName.toLowerCase().includes(action.text.toLowerCase()) || company.cuit.toLowerCase().includes(action.text.toLowerCase()));
      return {
        ...state,
        companyList: [...aux]
      };

    default:
      return state;
  }
}
